import React, { useEffect, useState } from 'react';

// Property type filter values
export const propertyTypes = [
  { key: 'detached', value: 'Detached' },
  { key: 'semidetached', value: 'Semi Detached' },
  { key: 'terrace', value: 'Terrace' },
  { key: 'bungalow', value: 'Bungalow' },
  { key: 'apartment', value: 'Apartment' },
];

// Plot status filter values
export const statuses = [
  { key: 'available', value: 'Available' },
  { key: 'coming-soon', value: 'Coming Soon' },
  { key: 'sold', value: 'Sold' },
];

// Bedroom filter values
export const beds = [
  { key: '1', value: '1' },
  { key: '2', value: '2' },
  { key: '3', value: '3' },
  { key: '4', value: '4' },
  { key: '5', value: '5' },
];

// Maximum price filter values
export const prices = [
  { key: 100000, value: '£100,000' },
  { key: 200000, value: '£200,000' },
  { key: 300000, value: '£300,000' },
  { key: 400000, value: '£400,000' },
  { key: 500000, value: '£500,000' },
  { key: 600000, value: '£600,000' },
  { key: 700000, value: '£700,000' },
  { key: 800000, value: '£800,000' },
  { key: 900000, value: '£900,000' },
  { key: 1000000, value: '£1,000,000' },
  { key: 1250000, value: '£1,250,000' },
  { key: 1500000, value: '£1,500,000' },
  { key: 1750000, value: '£1,750,000' },
  { key: 2000000, value: '£2,000,000' },
];

// Plus icon - used in the zoom button
export const PlusIcon = () => (
  <svg
    className="siteplan__icon siteplan__icon--plus"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" fill="currentColor">
        <polygon
          id="Path"
          points="6.75 0 5.25 0 5.25 5.25 0 5.25 0 6.75 5.25 6.75 5.25 12 6.75 12 6.75 6.75 12 6.75 12 5.25 6.75 5.25"
        />
      </g>
    </g>
  </svg>
);

// Minus icon - used in the zoom out button
export const MinusIcon = () => (
  <svg
    className="siteplan__icon siteplan__icon--minus"
    viewBox="0 0 12 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="12"
      y="0.75"
      width="1.5"
      height="12"
      transform="rotate(90 12 0.75)"
      fill="currentColor"
    />
  </svg>
);

// House icon - used on the apartment marker
export const HouseIcon = () => (
  <svg
    className="siteplan__house"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8917 8.63463V14.5996H8.4957V11.3876H6.0052V14.5996H2.6087V8.63463L0.950195 9.76563M11.8917 8.63463L7.2502 5.49963L2.6087 8.63563M11.8917 8.63463L13.5502 9.76513M15.4347 5.83513V11.8001H13.7797M15.4347 5.83513L17.0507 6.96513M15.4347 5.83513L10.9117 2.70013L8.6507 4.26763"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinejoin="round"
    />
  </svg>
);

// Expand icon - used in the full screen button
export const ExpandIcon = () => (
  <svg
    className="siteplan__icon siteplan__icon--expand"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0004 0.594189C18.0004 0.436392 17.938 0.285619 17.827 0.173909C17.7153 0.0629822 17.5645 0.000488281 17.4067 0.000488281H12.3634C12.0361 0.00126941 11.7713 0.266862 11.7713 0.594191C11.7713 0.921519 12.0361 1.18709 12.3634 1.18709H15.9749L11.9463 5.2157C11.8338 5.32663 11.7713 5.47818 11.7705 5.63598C11.7705 5.79378 11.833 5.94455 11.9447 6.05626C12.0556 6.16797 12.2072 6.23046 12.365 6.23046C12.5228 6.22968 12.6736 6.16641 12.7853 6.0547L16.8139 2.02609V5.63514C16.8139 5.96323 17.0795 6.22884 17.4068 6.22884C17.7349 6.22884 18.0005 5.96325 18.0005 5.63514L18.0004 0.594189Z"
      fill="currentColor"
    />
    <path
      d="M0.594213 18.0001H5.63752C5.96483 17.9994 6.22965 17.7338 6.22965 17.4064C6.22965 17.0791 5.96483 16.8135 5.63752 16.8135H2.02607L6.05688 12.7827C6.28732 12.5507 6.28654 12.1765 6.05532 11.9453C5.8241 11.7141 5.44992 11.7133 5.2179 11.9437L1.18709 15.9746V12.3631C1.18709 12.0358 0.921499 11.7702 0.594191 11.7702C0.266103 11.7702 0.000488281 12.0358 0.000488281 12.3631V17.4064C0.000488281 17.5642 0.0629822 17.715 0.173909 17.8267C0.285617 17.9376 0.436408 18.0001 0.594213 18.0001Z"
      fill="currentColor"
    />
  </svg>
);

// Filter icon - used in the filter button
export const FilterIcon = () => (
  <svg
    className="siteplan__filter-icon"
    viewBox="0 0 14 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" fill="currentColor">
        <path
          d="M7.247108,2.92267001 C7.075438,3.62171001 6.592688,4.20147001 5.937118,4.49580001 C5.368508,4.75668001 4.719398,4.77788001 4.135188,4.55602001 C3.411628,4.28507001 2.868658,3.67411001 2.685818,2.92267001 L0.570828,2.92267001 C0.255313,2.92267001 0,2.66736001 0,2.35184001 C0,2.03743001 0.255304,1.78101001 0.570828,1.78101001 L2.689158,1.78101001 C2.931098,0.811056008 3.761688,0.0997443079 4.758428,0.00943567789 C5.755148,-0.0797563921 6.699468,0.469894008 7.113098,1.38189001 C7.168848,1.51121001 7.214548,1.64499001 7.249088,1.78101001 L13.129198,1.78101001 C13.444798,1.78101001 13.700098,2.03743001 13.700098,2.35184001 C13.700098,2.66736001 13.444798,2.92267001 13.129198,2.92267001 L7.247108,2.92267001 Z M4.537918,3.48794001 L4.539038,3.48794001 L4.537948,3.49351001 C4.840088,3.60611001 5.174568,3.59273001 5.465548,3.45671001 C5.900368,3.25937001 6.17911212,2.82680001 6.17911212,2.34961001 C6.180208,2.17790001 6.142298,2.00845001 6.070948,1.85236001 C5.903688,1.48332001 5.563648,1.22244001 5.164528,1.15666001 C4.764258,1.08979001 4.358438,1.22802001 4.080828,1.52348001 C3.804318,1.81894001 3.692828,2.23368001 3.784258,2.62835001 C3.876788,3.02302001 4.158858,3.34523001 4.537918,3.48794001 Z M10.926198,8.20273001 C10.902698,8.29079001 10.877098,8.37664001 10.845898,8.46249001 C10.514798,9.36107001 9.671998,9.96760001 8.715338,9.99881001 C7.758768,10.0289 6.879128,9.47706001 6.490008,8.60300001 C6.432048,8.47475001 6.386338,8.34095001 6.353998,8.20273001 L0.570908,8.20273001 C0.255395,8.20273001 8.3e-05,7.94745001 8.3e-05,7.63189001 C8.3e-05,7.31747001 0.255386,7.06106001 0.570908,7.06106001 L6.350578,7.06106001 C6.373988,6.97521001 6.399628,6.88714001 6.430848,6.80129001 C6.649358,6.21707001 7.094208,5.74435001 7.663938,5.48903001 C8.299468,5.20249001 9.029678,5.21253001 9.657398,5.51579001 C10.285098,5.81904001 10.746698,6.38543001 10.917198,7.06106001 L13.129198,7.06106001 C13.444798,7.06106001 13.699998,7.31747001 13.699998,7.63189001 C13.699998,7.94737001 13.444798,8.20273001 13.129198,8.20273001 L10.926198,8.20273001 Z M7.420908,7.68098001 C7.436508,8.17152001 7.746438,8.60406001 8.205768,8.77691001 C8.507938,8.88842001 8.842368,8.87388001 9.133338,8.73680001 C9.425498,8.60749001 9.655198,8.36774001 9.769998,8.06900001 C9.820198,7.93185001 9.846898,7.78685001 9.846898,7.64087001 C9.846898,7.22944001 9.637298,6.84591001 9.291728,6.62293001 C8.944968,6.39884001 8.510138,6.36651001 8.134458,6.53597001 C7.687378,6.73887001 7.405308,7.19043001 7.420908,7.68098001 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

// Menu arrow - used in the dropdown select for the apartment floors
export const MenuArrow = ({ className }) => (
  <svg
    className={className || 'siteplan__floor-arrow'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7 4"
    fill="none"
  >
    <path
      d="M3.97366 0.167006C3.75045 -0.0562089 3.38795 -0.0562089 3.16473 0.167006L0.307589 3.02415C0.084375 3.24736 0.0843749 3.60986 0.307589 3.83308C0.530804 4.05629 0.893304 4.05629 1.11652 3.83308L3.57009 1.37951L6.02366 3.83129C6.24688 4.05451 6.60938 4.05451 6.83259 3.83129C7.0558 3.60808 7.0558 3.24558 6.83259 3.02236L3.97545 0.16522L3.97366 0.167006Z"
      fill="currentColor"
    />
  </svg>
);

// Close icon - close the filters
export const CloseIcon = ({ className }) => (
  <svg
    className={className || 'siteplan__close-icon'}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6155 1.65344C11.8279 1.44111 11.8279 1.09685 11.6156 0.884508C11.4032 0.672152 11.0589 0.672143 10.8466 0.884487L6 5.73102L1.1534 0.884486C0.941056 0.672143 0.596774 0.672153 0.384439 0.884508C0.172117 1.09685 0.172126 1.44111 0.384461 1.65344L5.23109 6.5L0.38446 11.3466C0.172126 11.5589 0.172117 11.9031 0.384439 12.1155C0.596774 12.3278 0.941056 12.3279 1.1534 12.1155L6 7.26898L10.8466 12.1155C11.0589 12.3279 11.4032 12.3278 11.6156 12.1155C11.8279 11.9031 11.8279 11.5589 11.6155 11.3466L6.76891 6.5L11.6155 1.65344Z"
      fill="currentColor"
    />
  </svg>
);

// Left arrow - used for the "back" button on the full screen map
export const LeftArrow = ({ className }) => (
  <svg
    className={className || 'siteplan__left-arrow'}
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.342593 4.41169C0.0190046 4.73708 0.0190046 5.26552 0.342593 5.59091L4.48453 9.75595C4.80811 10.0813 5.33362 10.0813 5.65721 9.75595C5.9808 9.43056 5.9808 8.90212 5.65721 8.57673L2.10033 5L5.65462 1.42327C5.97821 1.09788 5.97821 0.569439 5.65462 0.244045C5.33103 -0.0813485 4.80553 -0.0813485 4.48194 0.244045L0.340004 4.40908L0.342593 4.41169Z"
      fill="currentColor"
    />
  </svg>
);

// Collapse icon - used for the close state of the expand button
export const CollapseIcon = () => (
  <svg
    className="siteplan__icon siteplan__icon--collapse"
    viewBox="0 0 19 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" fill="currentColor" fillRule="nonzero">
        <path
          d="M6.2299,12.3637 C6.2299,12.2059 6.1674,12.0551 6.0565,11.9434 C5.9448,11.8325 5.794,11.77 5.6362,11.77 L0.59292,11.77 C0.26562,11.7708 0.0008,12.0364 0.0008,12.3637 C0.0008,12.6911 0.26562,12.9566 0.59292,12.9566 L4.2044,12.9566 L0.17576,16.9852 C0.06328,17.0962 0.00078,17.2477 0,17.4055 C0,17.5633 0.06249,17.7141 0.1742,17.8258 C0.28513,17.9375 0.43668,18 0.59448,18 C0.75228,17.9992 0.90305,17.9359 1.0148,17.8242 L5.0434,13.7956 L5.0434,17.4047 C5.0434,17.7328 5.309,17.9984 5.6363,17.9984 C5.9644,17.9984 6.23,17.7328 6.23,17.4047 L6.2299,12.3637 Z"
          id="Path"
        />
        <path
          d="M12.5937,6.2299 L17.637,6.2299 C17.9643,6.2292 18.2292,5.9636 18.2292,5.6362 C18.2292,5.3089 17.9643,5.0433 17.637,5.0433 L14.0256,5.0433 L18.0564,1.0125 C18.2868,0.78051 18.2861,0.40634 18.0548,0.17511 C17.8236,-0.05613 17.4494,-0.05691 17.2174,0.17354 L13.1866,4.2044 L13.1866,0.5929 C13.1866,0.26559 12.921,0 12.5937,0 C12.2656,0 12,0.26559 12,0.5929 L12,5.6362 C12,5.794 12.0625,5.9448 12.1734,6.0565 C12.2851,6.1674 12.4359,6.2299 12.5937,6.2299 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

// React hook to get the screen dimensions for the fullscreen map
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};

// Total filters applied helper function for the number shown in the filters button
export const filtersCount = (filters) => {
  let total = 0;

  if (filters?.bedrooms) {
    total += filters.bedrooms.length;
  }

  if (filters?.type) {
    total += filters.type.length;
  }

  if (filters?.status) {
    total += filters.status.length;
  }

  if (filters?.price) {
    total += filters.price.length;
  }

  if (filters?.ready_to_move_into === true) {
    total += 1;
  }

  return total;
};
